<template>
    <div class="content-body" v-show="!disabled" v-loading="loading">
        <el-row style="margin-bottom: 20px">
            <h1 id="pay_and_create_booking_title">
                お支払い
            </h1>
            <div id="booking_payment_rules_wrapper">
                <div id="booking_payment_rules_children_wrapper">
                    <div style="color: red; padding-left: 15px; padding-top: 10px">
                        ご予約はまだ確定していません
                    </div>
                    <div style="padding-left: 15px" v-html="bookingPaymentRules"></div>
                </div>
            </div>
        </el-row>

        <el-row>
            <div style="width: 30%; float: left; background-color: #b4d7ff; height: 40px">
                <p style="margin-top: 10px; margin-left: 20px">{{$t('bookingOrder.totalTitle')}}</p>
            </div>

            <div style="width: 70%; float: right; height: 40px;padding-top: 2px;" class="row">
                <p style="margin-top: 10px; margin-left: 40px">¥</p>
                <p style="margin-top: 10px; margin-left: 10px" ref="lastTotalFee">{{lastTotalFee}}</p>
            </div>
        </el-row>

        <el-row style="padding-top: 20px">
            <label>{{$t('bookingOrder.paymentMethod')}}</label>
        </el-row>

        <el-row style="padding-top: 20px; padding-bottom: 20px" class="row">
            <el-radio type="radio" style="margin-top: 5px;"></el-radio>
            <label>{{$t('bookingOrder.creditCardTitle')}}</label>
        </el-row>

        <label style="margin-left: 50px; color: red;"
               v-if="showRequiredMessage">{{$t("common.requiredMessage")}}
        </label>

        <div id="card-element">
        </div>

        <el-row class="pay_by_card_wrapper">
            <el-button id="pay_by_card_button" @click="pay">{{$t('bookingOrder.payByCardButton')}}</el-button>
        </el-row>

        <el-row class="cvc-icon-wrapper">
            <p>CVCとは</p>
            <el-col :span="4" :xs="10">
                <img class="cvc-icon" src="@/assets/images/CVC-1.png">
            </el-col>
            <el-col :span="4" :xs="10">
                <img class="cvc-icon" src="@/assets/images/CVC-2.png">
            </el-col>
        </el-row>

        <el-row class="pay_by_card_wrapper" style="margin-top: 20px;">
            <el-button style="width: 100%" @click="backConfirmToPay">{{$t('bookingOrder.backButton')}}</el-button>
        </el-row>


    </div>

</template>


<script>
    import AlertService from "../../../service/alert.service";
    import BookingApi from "../../../api/booking/BookingApi";
    import UserAPI from "../../../api/user/UserApi";

    export default {
        name: "PayAndCreateBooking",

        data() {
            return {
                stripe: "",
                disabled: true,
                lastTotalFee: 0,
                cardNumber: null,
                expiredMonth: null,
                expiredYear: null,
                cvcNumber: null,
                showRequiredMessage: false,
                card: "",
                token: "",
                createBookingDto: null,
                bookingDto: null,
                isDisabledPayButton: false,
                loading: false,
                isCheckedPayByCard: true,
                bookingPaymentRules: null,
                clientSecret: null
            }
        },

        created() {
            UserAPI.getBookingPaymentRulesByEndUser().then(result => {
                console.log("Rules 111:")
                console.log(result.rules)
                this.bookingPaymentRules = result.rules;
            })
        },

        watch: {
            bookingDto: function (bookingDto) {
                this.bookingDto = bookingDto;
            },

            isCheckedPayByCard() {
                this.isCheckedPayByCard = true;
            }
        },

        methods: {
            redirectToPayAndCreateBooking(bookingDto, totalFee) {
                console.log("Redirect to pay and create booking...")
                this.bookingDto = bookingDto;
                this.disabled = false;
                this.lastTotalFee = totalFee;
                console.log("Last total fee: " + this.lastTotalFee)
                this.$refs.lastTotalFee.innerText = this.lastTotalFee;
                this.initStripe()
            },

            initStripe(){
              this.includeStripe('js.stripe.com/v3/', function () {
                this.configureStripe();
              }.bind(this));
            },

            includeStripe(URL, callback) {
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = '//' + URL;
                if (callback) {
                    object.addEventListener('load', function (e) {
                        callback(null, e);
                    }, false);
                }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },

            async createPaymentIntent(fee){
              const response = await BookingApi.createBookingPaymentIntent(fee);
              return response.clientSecret;
            },
            async configureStripe() {
                this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
                this.clientSecret = await this.createPaymentIntent(this.lastTotalFee)
                const appearance = {
                  theme: 'stripe',
                };
                const clientSecret = this.clientSecret;
                this.elements = this.stripe.elements({ appearance, clientSecret });
                this.card = this.elements.create('card', {hidePostalCode: true});
                this.card.mount('#card-element');
            },

            setBookingDto(bookingDto) {
                this.bookingDto = bookingDto;
            },
            async pay() {
                this.loading = true;
                if(this.isDisabledPayButton){
                  return;
                }
                this.isDisabledPayButton = true;
                const bookingResult = await this.createBooking(this.bookingDto);
                if(bookingResult.bookingId) {
                  const card = this.card
                  const response = await this.stripe.confirmCardPayment(this.clientSecret, {
                    payment_method: {
                      card: card,
                      billing_details: {
                        email: bookingResult.username,
                        name: bookingResult.nameOfEndUser
                      },
                      metadata: {
                        bookingNumber: bookingResult.bookingNumber
                      }
                    },
                  });
                  if (response.error) {
                    if (response.error.payment_intent) {
                      // PaymentIntent client secret was invalid
                      await BookingApi.notifyPaymentFailed(bookingResult.bookingId, response.error.payment_intent.id);
                      AlertService.error(this.$t("bookingOrder.paymentFailed"))
                    } else {
                      AlertService.error(this.$t("bookingOrder.cardInfoNorExactly"))
                    }
                  } else {
                    if (response.paymentIntent.status === 'succeeded') {
                      // Show your customer that the payment has succeeded
                      await BookingApi.notifyPaymentSuccess(bookingResult.bookingId, response.paymentIntent.id);
                      this.moveToBookingConfirm(bookingResult.bookingNumber);
                    } else if (response.paymentIntent.status === 'requires_payment_method') {
                      // Authentication failed, prompt the customer to enter another payment method
                      await BookingApi.notifyPaymentFailed(bookingResult.bookingId, response.paymentIntent.id);
                      AlertService.error(this.$t("bookingOrder.cardInfoNorExactly"))
                    }
                  }
                }
                this.loading = false;
                this.isDisabledPayButton = false;
            },

            moveToBookingConfirm(bookingNumber) {
              this.$emit('redirectCompleteBooking', bookingNumber);
            },

            backConfirmToPay() {
                this.$emit('backConfirmToPay');
            },

            hide() {
                this.disabled = true;
            },

            show() {
                this.disabled = false;
            },

            enableLoading() {
                this.loading = true;
            },

            disableLoading() {
                this.loading = false;
            },

            async createBooking(bookingDto) {
              let createBookingDto = {
                booking: bookingDto
              };

              let timeRangeCustoms = createBookingDto.booking.bookingTimeRange.bookingTimeRangeCustoms;
              for (let i = 0; i < timeRangeCustoms.length; i++) {
                let dateWasReformatted = timeRangeCustoms[i].date.split("-").join("/");
                timeRangeCustoms[i].date = dateWasReformatted;
              }
              createBookingDto.booking.bookingTimeRange.bookingTimeRangeCustoms = timeRangeCustoms;

              console.log("Booking date: ", createBookingDto.booking.bookingDate)

              const result = await BookingApi.createBooking(createBookingDto)
              if (result.status.message === "SUCCESS") {
                  return result.data;
              } else {
                    const message = {
                      "EXCEED_LIMIT_BOOKING_SLOT": "bookingOrder.bookingNotEnoughSlot",
                      "EXCEED_LIMIT_USE_COUPON": "bookingOrder.runOutOfSlots",
                      "PAYMENT_FAIL": "bookingOrder.paymentFailed",
                    }
                    AlertService.error(this.$t(message[result.status.errorType]));
                    return undefined;
              }

            }
        },
    }
</script>


<style scoped lang="scss">
    .content-body {
        margin-right: 30%;
        margin-left: 30%;
    }

    #pay_and_create_booking_title {
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        margin-bottom: 10px;
    }

    #card-element {
        margin-right: 50px;
        margin-left: 50px;
        margin-top: 5px;
        border: 1px solid #8c939d;
        height: 37px;
        border-radius: 3px
    }

    .pay_by_card_wrapper {
        margin-right: 50px;
        margin-left: 50px;
        margin-top: 0px
    }

    #pay_by_card_button {
        width: 100%;
        background-color: #4B86E8;
        color: white
    }

    #booking_payment_rules_wrapper {
        width: 100%;
        display: inline-block;
        border: 1px solid red !important;
        border-radius: 15px;
    }

    /* #booking_payment_rules_children_wrapper{
         overflow: scroll;
         max-height: 80px;
         margin: 15px;
     }*/

    @media only screen and (max-width: 1024px) {
        .content-body {
            margin-left: 15%;
            margin-right: 15%;
        }
    }

    @media only screen and (max-width: 768px) {
        .content-body {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 450px) {
        .content-body {
            margin-right: 0%;
            margin-left: 0%;
        }

        #card-element {
            width: 100%;
            margin-top: 5px;
            border: 1px solid #8c939d;
            margin-right: 0px !important;
            height: 37px;
            border-radius: 3px;
            margin-left: 0px;
            margin-right: 0px;
        }

        .pay_by_card_wrapper {
            margin-right: 0px !important;
            margin-left: 0px;
            margin-top: 0px
        }

        #pay_by_card_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }

        #pay_and_create_booking_title {
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }

    .cvc-icon-wrapper {

        margin-right: 50px;
        margin-left: 50px;
        margin-top: 0px;

        @media only screen and (max-width: 450px) {
            margin-right: 20px;
            margin-left: 20px;
        }

        .cvc-icon {
            width: 50px;
            margin-left: 20px;
            height: auto;
        }

    }


</style>